import React from 'react';

import FactoringApprovalPending from './tabs/FactoringApprovalPending';
import FactoringRequests from './tabs/FactoringRequests';

export interface FactoringTabConfig {
  value: string;
  label: string;
  Component: React.ComponentType;
}

export const FACTORING_TABS: FactoringTabConfig[] = [
  {
    value: 'requests',
    label: 'Factoring',
    Component: FactoringRequests,
  },
  {
    value: 'approval-pending',
    label: 'Factoring',
    Component: FactoringApprovalPending,
  },
];

export const FACTORING_TAB_ITEMS = FACTORING_TABS.map(({ value, label }) => ({
  value,
  label,
}));

export const FACTORING_DEFAULT_TAB = FACTORING_TABS[0].value;

export const getTabComponent = (
  value: string,
): React.ComponentType | undefined =>
  FACTORING_TABS.find((tab) => tab.value === value)?.Component;
